import { Button } from '@unified-lk/ui'
import type { StaffPatientSegmentsData } from '../../types/plans'
import {
  workspaceActionsClassName,
  workspaceCardClassName,
  workspaceEmptyClassName,
  workspaceGridClassName,
  workspaceHeaderClassName,
  workspaceKickerClassName,
  workspaceMetricClassName,
  workspaceMutedTextClassName,
  workspacePanelClassName,
  workspaceSummaryGridClassName,
  workspaceTagClassName,
} from '../workspaceStyles'

export function PatientSegmentsSection({
  data,
  loading,
  error,
  onRetry,
}: {
  data: StaffPatientSegmentsData | null
  loading: boolean
  error: string | null
  onRetry: () => void
}) {
  if (loading && !data) {
    return <div className={workspaceEmptyClassName}><p>Загружаем сегменты пациентов...</p></div>
  }

  if (!data) {
    return <div className={workspaceEmptyClassName}><p>{error ?? 'Раздел сегментов пока недоступен.'}</p></div>
  }

  return (
    <div className={workspaceGridClassName}>
      <section className={workspacePanelClassName}>
        <div className={workspaceHeaderClassName}>
          <div className="grid gap-2">
            <p className={workspaceKickerClassName}>Segments</p>
            <h2 className="text-2xl font-semibold text-slate-900">Сегментация пациентов</h2>
            <p className={workspaceMutedTextClassName}>Сегменты, доступные для LK и внутренних коммуникационных сценариев.</p>
            {data.sources ? <p className="text-xs leading-5 text-slate-500">Source: `{data.sources.segments}`</p> : null}
          </div>
          <div className={workspaceActionsClassName}>
            <Button variant="secondary" type="button" onClick={onRetry}>Обновить</Button>
          </div>
        </div>

        <div className={workspaceSummaryGridClassName}>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">Всего</span><strong className="text-slate-900">{data.summary.total_segments}</strong></div>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">Для LK</span><strong className="text-slate-900">{data.summary.lk_segments}</strong></div>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">Dynamic</span><strong className="text-slate-900">{data.summary.dynamic_segments}</strong></div>
        </div>
      </section>

      <section className="grid gap-4 xl:grid-cols-2">
        {data.segments.map((segment) => (
          <article key={segment.id} className={workspaceCardClassName}>
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-lg font-semibold text-slate-900">{segment.title}</h3>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-700">{segment.patients_count}</span>
            </div>
            <p className={workspaceMutedTextClassName}>{segment.description ?? 'Описание не передано.'}</p>
            <div className={workspaceActionsClassName}>
              <span className={workspaceTagClassName()}>{segment.type}</span>
              {segment.for_lk ? <span className={workspaceTagClassName(true)}>for LK</span> : null}
            </div>
          </article>
        ))}
      </section>
    </div>
  )
}
